// Shared DEV-522 date rules for triggering brand research (mirrors the server's validation
// in brand-intelligence-console-server src/brands/research/research.service.ts).

// Floor for backdating: no social-ads source data exists before this, so an earlier
// valid_from would only produce empty estimates. Enforced server-side too (400).
export const MIN_VALID_FROM = '2026-05-01';

// Estimation covers dates after valid_from, so the trigger defaults a month back.
export const DEFAULT_BACKDATE_DAYS = 30;

// LOCAL calendar dates, never toISOString(): the native <input type="date"> and the user's
// mental model are local. UTC dates are off by one around midnight on both sides of UTC —
// for IL (UTC+3) between 00:00 and 03:00 local, UTC "today" is still yesterday, so a UTC max
// would forbid picking today. The server symmetrically accepts up to UTC today+1.
const toLocalIso = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export const todayIso = (): string => toLocalIso(new Date());

export const defaultValidFrom = (): string => {
  const date = new Date();
  date.setDate(date.getDate() - DEFAULT_BACKDATE_DAYS);
  const iso = toLocalIso(date);
  return iso < MIN_VALID_FROM ? MIN_VALID_FROM : iso;
};
